import React from 'react';
import Promotion from '../Promotion/Promotion';
import PromotionFeatured from '../PromotionFeatured/PromotionFeatured';
import { GridReveal, GridItem } from '../UI/Grid/Grid';
import Section from '../UI/Section/Section';
import * as styles from './Promotions.module.scss';

const Promotions = ({ items, ...other }) => {
  return !items.length ? null : items.length === 1 ? (
    <PromotionFeatured {...items[ 0 ]} />
  ) : (
    <Section {...other}>
      <GridReveal>
        {items.map((promotion) => {
          return promotion && promotion.title ? (
            <GridItem key={promotion.id} lg={6}>
              <Promotion {...promotion} />
            </GridItem>
          ) : null;
        })}
      </GridReveal>
    </Section>
  );
};

export default Promotions;
